<section class="workspace-section">
    <div class="section-toolbar">
        <div>
            <h3>Shipment Files</h3>
            <p>Shipment and delivery attachments with their owning delivery tags.</p>
        </div>
        @if (canManageFiles()) {
            <p-button label="Add File" severity="help" icon="fa-solid fa-plus" (onClick)="command.emit({ type: 'add-file' })"></p-button>
        }
    </div>

    @if (files().length > 0) {
        <div class="file-grid">
            @for (orderFile of files(); track orderFile.fileUrl) {
                <div class="file-tile">
                    <app-attachment-preview [url]="orderFile.fileUrl" [name]="orderFile.fileName"></app-attachment-preview>
                    <a [href]="orderFile.fileUrl" target="_blank" rel="noopener">
                        <strong>{{ orderFile.fileName }}</strong>
                        <span>{{ orderFile.fileType || 'Attachment' }}</span>
                        <small>{{ formattedCreationDate(orderFile.creationDate) }}</small>
                        <div class="file-scope-tag" [class.shipment-level]="isShipmentLevel(orderFile)">
                            <i [class]="scopeIcon(orderFile)"></i>
                            <div>
                                <strong>{{ scopeLabel(orderFile) }}</strong>
                                <span>{{ scopeSubtitle(orderFile) }}</span>
                            </div>
                        </div>
                    </a>
                    @if (canManageFiles()) {
                        <button pButton type="button" icon="pi pi-trash" severity="danger" [rounded]="true" [text]="true"
                            pTooltip="Delete attachment" (click)="command.emit({ type: 'delete-file', file: orderFile })"></button>
                    }
                </div>
            }
        </div>
    } @else {
        <div class="empty-state">
            <i class="fa-solid fa-paperclip"></i>
            <strong>No shipment files</strong>
            <span>Upload contracts, waybills, or supporting shipment documents.</span>
        </div>
    }
</section>
